export default {
  distanceToStart: '距離活動開始還有',
  distanceToEnd: '距離活動結束還有',
  ended: '活動已結束',
  moonPhase: {
    introduction: '月相會隨著活動期間的全服玩家彩鑽充值進度而增加，達到滿月後，所有參與本活動的玩家都可以獲得滿月限定獎勵[稱號-月滿中秋]',
    new_moon: '新月',
    crescent_moon: '峨眉月',
    first_quarter: '上弦月',
    gibbous_moon: '盈凸月',
    full_moon: '滿月',
  },
  rewards: {
    clickHere: '點此前往',
    introduceText1: '前往線上儲值頁面[{clickHere}]，累計儲值達到200/500/1000/3000/5000/8000彩鑽，即可領取里程碑獎勵',
    introduceText2: '活動時間：2026年9月25日01:00 ~ 2026年10月5日00:59（GMT+8）',
    introduceText3: '獎勵領取時間將於2026年10月5日00:59（GMT+8）',
  }
}